import { AsyncPipe } from '@angular/common'
import { Component } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { LoaderFullService } from './loader-full.service'

@Component({
    selector: 'loader-full-fragment',
    templateUrl: './loader-full.fragment.html',
    styleUrls: ['./loader-full.fragment.scss'],
    imports: [AsyncPipe, TranslateModule]
})
export class LoaderFullFragment {
  constructor(public loaderFull: LoaderFullService) {}
}
